module.exports = __webpack_public_path__ + "static/img/Logo Bible_Search_White_Circle.9f8a3bfb.png";